import React from 'react'

import { useFloorState } from '../../../../firebase/hooks/useFloor'
import { useOverlayState } from '../../../../firebase/hooks/useOverlays'
import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useFullParticipantInfo } from '../../../../webrtc/webRTCRoom'
import { posToStyle, useFeedPosition } from '../../../layouts'

import './FloorCameraFeed.scss'

interface FloorCameraFeedProps {
  id: number
}

const FloorCameraFeed = ({ id }: FloorCameraFeedProps) => {
  const participant = useFullParticipantInfo(id)
  const floor = useFloorState()
  const overlay = useOverlayState()
  const position = useFeedPosition('camera', id)

  if (!participant?.tracks.camera) return null

  return (
    <div className="participant-video-track" style={posToStyle(position)}>
      <VideoTrack track={participant.tracks.camera} objectFit="cover" />
      {floor?.layout === 'panel' &&
        participant.isShowingTvCards &&
        !overlay && <div className="name-tag">{participant.name}</div>}
    </div>
  )
}

export { FloorCameraFeed }
